import { ChangeEvent, Fragment } from 'react';

import { LabelInput, SpeechBubble } from '../../shared';

import {
    isDistrictAction,
    isPackAction,
    isSceneAction,
    isTabAction,
} from '../utils';

import { BannerActionType } from '../../types/enums/bannerType.enum';

import { Banner } from '../../types/bannerTypes';

export enum PossibleBannerActionParameters {
    PackId = 'packId',
    SceneName = 'sceneName',
    XPosition = 'xPosition',
    TabStringId = 'tabStringId',
    DistrictId = 'districtId',
}

const ActionTypeDisplayName = {
    [BannerActionType.OPEN_SHOP]: 'Shop Home',
    [BannerActionType.OPEN_PDP]: 'Shop Pack',
    [BannerActionType.OPEN_SCENE]: 'Scene',
    [BannerActionType.OPEN_DISTRICT]: 'Map',
    [BannerActionType.OPEN_TAB]: 'Shop Tab',
};

type BannerActionProps = {
    type: Banner['actionType'];
    parameters: Banner['actionParameters'];
    onTypeChange: (e: ChangeEvent<HTMLInputElement>) => void;
    onInputChange: (e: ChangeEvent<HTMLInputElement>) => void;
};

export const BannerAction = (props: BannerActionProps) => {
    const { parameters, type, onInputChange, onTypeChange } = props;

    const getActionParametersFields = () => {
        if (type === BannerActionType.OPEN_SHOP) {
            return (
                <SpeechBubble
                    style={{
                        justifyContent: 'left',
                        marginTop: 10,
                        marginBottom: 20,
                    }}
                >
                    That’s all! No ID needed for Shop home :)
                </SpeechBubble>
            );
        }

        if (type === BannerActionType.OPEN_TAB) {
            return (
                <div>
                    <LabelInput
                        size="semiwide"
                        name={PossibleBannerActionParameters.TabStringId}
                        value={
                            isTabAction(parameters)
                                ? parameters.tabStringId
                                : ''
                        }
                        tooltip="Tapping the banner will take the user to this tab in the shop"
                        label="Tab String ID"
                        onChange={onInputChange}
                    />
                </div>
            );
        }

        if (type === BannerActionType.OPEN_DISTRICT) {
            return (
                <div>
                    <SpeechBubble
                        style={{
                            justifyContent: 'left',
                            marginTop: 10,
                            marginBottom: 20,
                        }}
                    >
                        <strong>Important!</strong> Only link to free content
                    </SpeechBubble>
                    <LabelInput
                        size="semiwide"
                        name={PossibleBannerActionParameters.DistrictId}
                        value={
                            isDistrictAction(parameters)
                                ? parameters.districtId
                                : ''
                        }
                        tooltip="Tapping the banner will take the user to this district in the World Map"
                        label="District ID"
                        onChange={onInputChange}
                    />
                </div>
            );
        }

        if (type === BannerActionType.OPEN_PDP) {
            return (
                <div>
                    <LabelInput
                        size="semiwide"
                        name={PossibleBannerActionParameters.PackId}
                        value={
                            isPackAction(parameters) ? parameters?.packId : ''
                        }
                        tooltip="Tapping the banner will take the user to this pack in the shop"
                        label="Pack ID"
                        onChange={onInputChange}
                    />
                </div>
            );
        }

        if (type === BannerActionType.OPEN_SCENE) {
            return (
                <div>
                    <SpeechBubble
                        style={{
                            justifyContent: 'left',
                            marginTop: 10,
                            marginBottom: 20,
                        }}
                    >
                        <strong>Important!</strong> Only link to free content
                    </SpeechBubble>
                    <LabelInput
                        size="semiwide"
                        name={PossibleBannerActionParameters.SceneName}
                        value={
                            isSceneAction(parameters)
                                ? parameters.sceneName
                                : ''
                        }
                        tooltip="Tapping the banner will take the user to this scene and coordinate"
                        label="Scene name"
                        onChange={onInputChange}
                    />
                    <LabelInput
                        size="semiwide"
                        name={PossibleBannerActionParameters.XPosition}
                        type={'number'}
                        value={
                            isSceneAction(parameters)
                                ? parameters.xPosition
                                : ''
                        }
                        label="Camera position"
                        onChange={onInputChange}
                    />
                </div>
            );
        }

        return null;
    };

    return (
        <>
            <fieldset>
                <legend>Link type</legend>
                {Object.values(BannerActionType).map((option) => (
                    <Fragment key={option}>
                        <input
                            checked={type === option}
                            id={option}
                            name="actionType"
                            type="radio"
                            value={option}
                            onChange={onTypeChange}
                        />
                        <label htmlFor={option}>
                            {ActionTypeDisplayName[option]}
                        </label>
                    </Fragment>
                ))}
            </fieldset>
            {getActionParametersFields()}
        </>
    );
};
